var _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoRingsInvert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 516,
    viewBox: "0 0 516 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 258,
    r: 204.146,
    stroke: "#E7E7E7",
    strokeOpacity: 0.4,
    strokeWidth: 2.50485
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 258,
    r: 256.748,
    stroke: "#E7E7E7",
    strokeOpacity: 0.2,
    strokeWidth: 2.50485
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.417,
    cy: 257.582,
    r: 138.602,
    stroke: "#E7E7E7",
    strokeOpacity: 0.6,
    strokeWidth: 2.50485
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 258,
    r: 77.233,
    stroke: "#E7E7E7",
    strokeOpacity: 0.8,
    strokeWidth: 2.50485
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.418,
    cy: 257.583,
    r: 30.8932,
    stroke: "#E7E7E7",
    strokeWidth: 2.50485
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoRingsInvert);
export default __webpack_public_path__ + "static/media/deco-rings-invert.ad896cb4c9a8e8d02c8c9438713d3f8c.svg";
export { ForwardRef as ReactComponent };